<script setup lang="ts">

import { beautyPhoneNumber } from '@/utils/helper.ts'
import { computed } from 'vue'
interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()
const value = computed(() => {
  if(typeof props.data === 'string') return props.data
  return '--'
})
</script>

<template>
  <div class="table-cell">
    {{beautyPhoneNumber( value )}}
  </div>
</template>

<style scoped>

</style>
